// extracted by mini-css-extract-plugin
export default {"textarea-label":"TextArea_textarea-label__54458","textarea":"TextArea_textarea__swHbc","is-error":"TextArea_is-error__wN1kN","textarea-error":"TextArea_textarea-error__MKG5s"};